export const getAvatarPathBySize = (files, pathSize) => {
  if (files && files.length) {
    return files[0][pathSize];
  }
  return '';
};
